import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {CreditAssessmentService} from '../../service/credit-assessment.service';
import {Keys, StorageService} from '../../service/storage.service';
import {CreditAssessment} from '../../model/eligibility-check/credit-assessment.model';
import {SharedEligibilityCheckForm} from './eligibility-check-form/eligibility-check-form.component';
import {SelectedOptionResolver} from './selected-option.resolver';

@Injectable()
export class CreditAssessmentInfoResolver implements Resolve<CreditAssessment> {
    constructor(private selectedOptionResolver: SelectedOptionResolver,
                private creditAssessmentService: CreditAssessmentService, private storageService: StorageService) {
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<CreditAssessment> {
        const selectedOption = await this.selectedOptionResolver.resolve(route, state);
        return selectedOption ? await this.creditAssessmentService.getAssessmentByCreditOptionId(selectedOption.getCreditOptionId()) : undefined;
    }

    public getLocallySavedEligibilityCheck(): SharedEligibilityCheckForm {
        const state = this.storageService.getObject<{ eligibilityCheckForm: SharedEligibilityCheckForm }>(Keys.EXTRA_OPTIONS_STATE);
        return state ? state.eligibilityCheckForm : undefined;
    }
}
